"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLegacyCustomKey = isLegacyCustomKey;
exports.getLegacyColor = getLegacyColor;
const styles_1 = require("@aurora/shared-types/styles");
const log_1 = require("@aurora/shared-utils/log");
const log = (0, log_1.getLog)(module);
/**
 * whether the color is a legacy color key
 *
 * @param color the color
 */
function isLegacyCustomKey(color) {
    return color.startsWith('custom-');
}
/**
 * Mapping of legacy colors to var() wrapped CSS variable equivalent.
 */
const legacyColorMap = {
    'custom-1': styles_1.CommonColorCssVariables.WHITE,
    'custom-2': styles_1.CommonColorCssVariables.BLACK,
    'custom-3': styles_1.CommonColorCssVariables.BODY_BG,
    'custom-4': styles_1.CommonColorCssVariables.GRAY_800,
    'custom-5': styles_1.CommonColorCssVariables.GRAY_400,
    'custom-6': styles_1.CommonColorCssVariables.BODY_TEXT,
    'custom-7': null,
    'custom-8': null,
    'custom-9': null,
    'custom-10': null
};
/**
 * Converts a legacy color key into a valid CSS color. This was only added to support a format
 * or color keys that was initially used in Aurora that has since been replace with CSS variables
 * and that should ultimately be removed once all references to these keys are removed from any quilt overrides.
 *
 * @param theme the theme
 * @param colorKey the color key
 *
 * @author Adam Ayres
 */
function getLegacyColor(colorKey) {
    const newColor = legacyColorMap[colorKey];
    log.warn('A legacy color value has been used: %s. This should be replaced with: %s', colorKey, newColor !== null && newColor !== void 0 ? newColor : 'a common or custom color value.');
    return newColor !== null && newColor !== void 0 ? newColor : styles_1.CommonColorCssVariables.GRAY_500;
}
//# sourceMappingURL=LegacyColorHelper.js.map